export const SDK_VERSION = '7.52.0';
